import { Button, Stack,  Typography } from "@mui/material";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";

interface NoPolicyBannerProps {
  canSet: boolean;
  onSetPolicy: () => void;
}

export const NoPolicyBanner: React.FC<NoPolicyBannerProps> = ({ canSet, onSetPolicy }) => (
  <Stack
    direction="row"
    alignItems="center"
    justifyContent="space-between"
    gap="16px"
    sx={{
      width: "100%",
      backgroundColor: "#ffffff",
      borderRadius: "8px",
      padding: "12px 16px",
      boxShadow: "0px 1px 2px 0px rgba(18, 18, 23, 0.1)"
    }}
  >
    <Stack direction="row" alignItems="flex-start" gap="10px" sx={{ minWidth: 0 }}>
      <InfoOutlinedIcon sx={{ fontSize: 20, flexShrink: 0, mt: "2px" }} />
      <Stack sx={{ minWidth: 0 }}>
        <Typography
          sx={{
            fontSize: "14px",
            fontWeight: 500,
            color: "#071f35"
          }}
        >
          No target policy
        </Typography>
        <Typography
          sx={{
            fontSize: "13px",
            lineHeight: "18px",
            color: "#071f35"
          }}
        >
          No allocation targets have been set for this slice.
        </Typography>
      </Stack>
    </Stack>
    {canSet && (
      <Button
        onClick={onSetPolicy}
        sx={{
          color: "white",
          backgroundColor: "#071f35",
          padding: "6px 14px",
          minWidth: 0,
          minHeight: 0,

          fontSize: "13px",
          fontWeight: 500,
          lineHeight: "16px",
          textTransform: "none",
          borderRadius: "32px",
          flexShrink: 0,
          "&:hover": { backgroundColor: "#0d2c4d" }
        }}
      >
        Set Policy
      </Button>
    )}
  </Stack>
);
